import React from 'react';
import styled from 'styled-components';
import Icon from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import useTooltipLayer from '~/hooks/useTooltipLayer';

const text = { label: 'Recentste notitie:' };

export type Props = {
  dataTestId?: string;
  className?: string;
  latestComment: string;
  commentsCount: number;
};

const CommentsIndicator: React.FCC<Props> = ({
  dataTestId,
  className,
  latestComment,
  commentsCount,
}) => {
  const toolTipProps = useTooltipLayer({
    tooltipMessage: (
      <JustificationContainer direction="column">
        <Body size="s" fontWeight="semiBold" color={{ group: 'white' }}>
          {text.label}
        </Body>
        <Body size="s" margin={[null]} color={{ group: 'white' }}>
          {latestComment}
        </Body>
      </JustificationContainer>
    ),
  });
  return (
    <Container
      dataTestId={dataTestId}
      className={className}
      {...toolTipProps}
      gap="xxxs"
    >
      <Icon name="message-square" />
      <Body size="s" margin={[null, null, 'xxxs', null]}>
        {commentsCount}
      </Body>
    </Container>
  );
};

const Container = styled(JustificationContainer)`
  cursor: pointer;
`;

export default CommentsIndicator;
